import React, {ReactNode, useRef} from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, onDesktop, p} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {NAVIGATION_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {useClickOutside} from "../../../../hooks/handle_click_outside";
import {SearchDropdownArrow} from "../../../../search/components/atoms/SearchDropdownArrow";
import {filterHolder, filterLabel, filterLabelText} from "../../../../search/components/filters/SearchRangeFilter";
import {SortOptionsValues} from "../../types/SortOptionsValues";

interface IProps {
    children: ReactNode;
    isDropdownOpen: boolean;
    setDropdownOpen: (setIsOpen: boolean) => void;
    isMobile: boolean;
    setDesktopFilterBlendActive?: (isOpen: boolean) => void;
    rightDropdown?: boolean;
    disableClearAction?: boolean;
    currentValue: SortOptionsValues;
    sortOptions: {label: string; value: number; slug?: string}[];
    setCurrentValue: (value: number) => void;
    dropdownShadow?: boolean;
    closeOnOutsideClick?: boolean;
}
export const Sort = (props: IProps) => {
    const wrapperRef = useRef(null);
    const isSorted = props.currentValue !== SortOptionsValues.NOT_SELECTED;

    const handleClick = () => {
        props.setDropdownOpen(!props.isDropdownOpen);
        props.setDesktopFilterBlendActive && props.setDesktopFilterBlendActive(!props.isDropdownOpen);
    };

    const onClear = (event: React.MouseEvent | React.KeyboardEvent) => {
        event.stopPropagation();
        props.setCurrentValue && props.setCurrentValue(SortOptionsValues.NOT_SELECTED);
        props.setDesktopFilterBlendActive && props.setDesktopFilterBlendActive(false);
    };

    const getSortLabel = (value: number) => {
        return props.sortOptions.filter((el) => el.value === value)?.[0]?.label || "";
    };

    useClickOutside(wrapperRef, () => props.closeOnOutsideClick && props.setDropdownOpen(false));

    return (
        <div css={filterHolder} ref={wrapperRef}>
            <div tabIndex={-1} css={filterLabel} onClick={handleClick} data-testid={NAVIGATION_TEST_IDS.SORT_BUTTON}>
                <Text variant="body_copy_2" css={filterLabelText}>
                    Sortuj
                    {isSorted && (
                        <>
                            <br />
                            <Text variant="info_txt_2" as="span" css={subLabel}>
                                {getSortLabel(props.currentValue)}
                            </Text>
                        </>
                    )}
                </Text>

                {isSorted && !props.disableClearAction ? (
                    <div onClick={(event) => onClear(event)}>
                        <CloseIcon size="2" />
                    </div>
                ) : (
                    <SearchDropdownArrow isDown={props.isDropdownOpen} />
                )}
            </div>

            {props.isDropdownOpen && (
                <DropdownHolder rightDropdown={props.rightDropdown} dropdownShadow={props.dropdownShadow}>
                    <Text variant="body_copy_1">Sortuj</Text>
                    {props.children}
                </DropdownHolder>
            )}
        </div>
    );
};

interface IDropdownHolderProps {
    rightDropdown?: boolean;
    dropdownShadow?: boolean;
}

const DropdownHolder = styled.div<IDropdownHolderProps>`
    background: #fff;

    ${p(2, 1)};
    ${(props) =>
        onDesktop(css`
            position: absolute;
            top: 6rem;
            z-index: 1001;
            min-width: 36rem;
            max-height: 60rem;

            ${p(3, 4, 2, 4)}
            ${borderRadius(4)}
            right: ${props.rightDropdown ? 0 : "initial"};
            ${elevation(props.dropdownShadow ? 1 : 0)};
        `)};
`;

const subLabel = (theme: Theme) => css`
    color: ${theme.colors.gray[700]};
`;
import React, {ReactNode, useRef} from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, onDesktop, p} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {NAVIGATION_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {useClickOutside} from "../../../../hooks/handle_click_outside";
import {SearchDropdownArrow} from "../../../../search/components/atoms/SearchDropdownArrow";
import {filterHolder, filterLabel, filterLabelText} from "../../../../search/components/filters/SearchRangeFilter";
import {SortOptionsValues} from "../../types/SortOptionsValues";

interface IProps {
    children: ReactNode;
    isDropdownOpen: boolean;
    setDropdownOpen: (setIsOpen: boolean) => void;
    isMobile: boolean;
    setDesktopFilterBlendActive?: (isOpen: boolean) => void;
    rightDropdown?: boolean;
    disableClearAction?: boolean;
    currentValue: SortOptionsValues;
    sortOptions: {label: string; value: number; slug?: string}[];
    setCurrentValue: (value: number) => void;
    dropdownShadow?: boolean;
    closeOnOutsideClick?: boolean;
}
export const Sort = (props: IProps) => {
    const wrapperRef = useRef(null);
    const isSorted = props.currentValue !== SortOptionsValues.NOT_SELECTED;

    const handleClick = () => {
        props.setDropdownOpen(!props.isDropdownOpen);
        props.setDesktopFilterBlendActive && props.setDesktopFilterBlendActive(!props.isDropdownOpen);
    };

    const onClear = (event: React.MouseEvent | React.KeyboardEvent) => {
        event.stopPropagation();
        props.setCurrentValue && props.setCurrentValue(SortOptionsValues.NOT_SELECTED);
        props.setDesktopFilterBlendActive && props.setDesktopFilterBlendActive(false);
    };

    const getSortLabel = (value: number) => {
        return props.sortOptions.filter((el) => el.value === value)?.[0]?.label || "";
    };

    useClickOutside(wrapperRef, () => props.closeOnOutsideClick && props.setDropdownOpen(false));

    return (
        <div css={filterHolder} ref={wrapperRef}>
            <div tabIndex={-1} css={filterLabel} onClick={handleClick} data-testid={NAVIGATION_TEST_IDS.SORT_BUTTON}>
                <Text variant="body_copy_2" css={filterLabelText}>
                    Sortuj
                    {isSorted && (
                        <>
                            <br />
                            <Text variant="info_txt_2" as="span" css={subLabel}>
                                {getSortLabel(props.currentValue)}
                            </Text>
                        </>
                    )}
                </Text>

                {isSorted && !props.disableClearAction ? (
                    <div onClick={(event) => onClear(event)}>
                        <CloseIcon size="2" />
                    </div>
                ) : (
                    <SearchDropdownArrow isDown={props.isDropdownOpen} />
                )}
            </div>

            {props.isDropdownOpen && (
                <DropdownHolder rightDropdown={props.rightDropdown} dropdownShadow={props.dropdownShadow}>
                    <Text variant="body_copy_1">Sortuj</Text>
                    {props.children}
                </DropdownHolder>
            )}
        </div>
    );
};

interface IDropdownHolderProps {
    rightDropdown?: boolean;
    dropdownShadow?: boolean;
}

const DropdownHolder = styled.div<IDropdownHolderProps>`
    background: #fff;

    ${p(2, 1)};
    ${(props) =>
        onDesktop(css`
            position: absolute;
            top: 6rem;
            z-index: 1001;
            min-width: 36rem;
            max-height: 60rem;

            ${p(3, 4, 2, 4)}
            ${borderRadius(4)}
            right: ${props.rightDropdown ? 0 : "initial"};
            ${elevation(props.dropdownShadow ? 1 : 0)};
        `)};
`;

const subLabel = (theme: Theme) => css`
    color: ${theme.colors.gray[700]};
`;
